// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"589":"2a268786","854":"3460f52b"}[chunkId] + ".js";
};